import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import CalendarizeComponent from "@/components/Atoms/CalendarizeEmbedded"
import { useAuth } from "@/modules/Auth/context/AuthContext"

interface MentoringModalProps {
  isOpen: boolean
  onClose: () => void
  calLink: string
  onBookingSuccess?: () => void
}

export function MentoringModal({
  isOpen,
  onClose,
  calLink,
  onBookingSuccess,
}: MentoringModalProps) {
  const { user } = useAuth()

  return (
    <Dialog
      open={isOpen}
      onOpenChange={onClose}
    >
      <DialogContent className="flex h-[80vh] flex-col sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Agende sua mentoria</DialogTitle>
        </DialogHeader>
        <CalendarizeComponent
          userName={user.pesNome}
          userEmail={user.pesEmail}
          emp_id={user.empId}
          link={calLink}
          onBookingSuccess={onBookingSuccess}
        />
      </DialogContent>
    </Dialog>
  )
}
